import React from 'react'

const GithubRibbon = () => {
  return (
    <a href="https://github.com/yashmantri20/FizzBuzz-Component-Library" style={{ position: 'fixed', right: 0, zIndex: 99 }} target="_blank" rel="noopener noreferrer">
      <img loading="lazy" width="130" height="130" src="https://github.blog/wp-content/uploads/2008/12/forkme_right_darkblue_121621.png?resize=149%2C149" className="ribbon attachment-full size-full" alt="Fork me on GitHub" data-recalc-dims="1" />
    </a>
  )
}

export default GithubRibbon
